import React from 'react';

import { fractionToPercent } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { AssetCategory } from 'common/interfaces';

interface Props {
  terAverage: number;
  distributionTotal: number;
  data: AssetCategory[];
  savingIsins: string[];
}

const PortfolioTable = (props: Props) => {
  const style = useGeneralStyles();
  const tables = useTableStyles();
  const { data } = props;

  return (
    <table className={`${tables.root} ${tables.portfolio}`}>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th className={style.left}>Název instrumentu</th>
          <th>ISIN</th>
          <th>Roční nákladovost</th>
          <th>Cílové zastoupení</th>
        </tr>
      </thead>

      <tbody>
        {data.map((assetCategory) => {
          const categorySize = assetCategory.assetClasses.length;

          return assetCategory.assetClasses.map((assetClass, i) => {
            const classSize = assetClass.assets?.length || 0;

            return assetClass.assets?.map((asset, x) => {
              return (
                <tr className={categorySize === i + 1 && classSize === x + 1 ? 'divider' : undefined} key={asset.isin}>
                  <td className={`${assetCategory.code}`}>&nbsp;</td>
                  <td className={style.left}>{asset.originalTitle}</td>
                  <td>{props.savingIsins?.includes(asset.isin) ? '' : asset.isin}</td>
                  <td>{typeof asset.ter === 'number' && fractionToPercent(asset.ter, 2)}</td>
                  <td>{fractionToPercent(asset.share)}</td>
                </tr>
              );
            });
          });
        })}
        <tr className="total">
          <td>&nbsp;</td>
          <td className={`${style.left}`}>Celkem</td>
          <td>&nbsp;</td>
          <td>{typeof props.terAverage === 'number' && fractionToPercent(props.terAverage, 2)}</td>
          <td>{fractionToPercent(props.distributionTotal)}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default PortfolioTable;
